import React, { useEffect } from 'react';
import './SequenceHistory.scss';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getEnrollmentStatus } from '../../../../../../redux/actions/sequenceAction/SequenceAction';

function SequenceHistory() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const enrollmentData = useSelector((state) => state.sequenceReducer?.enrollmentStatus);

  useEffect(() => {
    if (id) {
      dispatch(getEnrollmentStatus(id));
    }
  }, [id, dispatch]);

  // If no active enrollment, don't render the component
  if (!enrollmentData || !enrollmentData.hasActiveEnrollment) {
    return null;
  }

  const { enrollment } = enrollmentData;
  const sequenceName = enrollment?.sequenceId?.name || 'Sequence';
  const stepHistory = enrollment?.stepHistory || [];
  const status = enrollment?.status || 'unknown';

  // Sort step history by step number (most recent first for display)
  const sortedHistory = [...stepHistory].sort((a, b) => b.stepNumber - a.stepNumber);

  const getStatusIcon = (stepStatus) => {
    switch (stepStatus) {
      case 'executed':
        return <i className="fas fa-check-circle status-icon status-executed" title="Executed"></i>;
      case 'pending':
        return <i className="fas fa-clock status-icon status-pending" title="Pending"></i>;
      case 'skipped':
        return <i className="fas fa-forward status-icon status-skipped" title="Skipped"></i>;
      default:
        return <i className="fas fa-question-circle status-icon status-unknown"></i>;
    }
  };

  const getStatusBadgeClass = (currentStatus) => {
    switch (currentStatus) {
      case 'active':
        return 'status-badge status-badge-active';
      case 'completed':
        return 'status-badge status-badge-completed';
      case 'paused':
        return 'status-badge status-badge-paused';
      case 'exited':
        return 'status-badge status-badge-exited';
      default:
        return 'status-badge';
    }
  };

  return (
    <div className="sequence-history-container">
      <div className="sequence-history-header">
        <div className="common-subtitle">SEQUENCE HISTORY</div>
        <span className={getStatusBadgeClass(status)}>
          {status.toUpperCase()}
        </span>
      </div>

      <div className="sequence-info-card mt-10">
        <div className="sequence-info-row">
          <i className="fas fa-project-diagram sequence-icon"></i>
          <span className="sequence-name-text">{sequenceName}</span>
        </div>
        <div className="sequence-stats">
          <span className="stat-item">
            <i className="fas fa-list-ol"></i> {stepHistory.length} Step{stepHistory.length !== 1 ? 's' : ''}
          </span>
          <span className="stat-item">
            <i className="fas fa-check"></i> {stepHistory.filter(s => s.status === 'executed').length} Executed
          </span>
        </div>
      </div>

      <div className="step-history-list mt-10">
        {sortedHistory.length > 0 ? (
          sortedHistory.map((step, index) => (
            <div key={`${step.stepNumber}-${index}`} className="step-history-item">
              <div className="step-header">
                <div className="step-title-row">
                  {getStatusIcon(step.status)}
                  <span className="step-name">
                    Step {step.stepNumber}: {step.stepName}
                  </span>
                </div>
                {step.status === 'executed' && step.executedAt && (
                  <div className="step-timestamp">
                    {moment(step.executedAt).format('DD/MM/YYYY | hh:mm A')}
                  </div>
                )}
                {step.status === 'pending' && step.scheduledFor && (
                  <div className="step-timestamp pending-timestamp">
                    Scheduled: {moment(step.scheduledFor).format('DD/MM/YYYY')}
                  </div>
                )}
              </div>

              {step.status === 'executed' && step.messageUsed && (
                <div className="step-details">
                  <div className="message-preview">
                    {step.messageUsed}
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-history-message">No sequence steps recorded</div>
        )}
      </div>
    </div>
  );
}

export default SequenceHistory;
